const InfologReceptionFilesIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2141_25726)" />
      <path
        d="M46.0199 25.3529H40.853V20.186L46.0199 25.3529ZM46.7059 27.694V50.5H23.2944V23.0117C23.2944 22.0804 23.6644 21.1871 24.323 20.5286C24.9816 19.87 25.8748 19.5 26.8062 19.5H38.5119V27.694H46.7059ZM29.1473 38.2292H37.3413V35.888H29.1473V38.2292ZM40.853 40.5703H29.1473V42.9115H40.853V40.5703ZM40.853 31.2057H29.1473V33.5469H40.853V31.2057Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2141_25726"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CFCF14" />
          <stop offset="1" stop-color="#A7A703" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default InfologReceptionFilesIconSubcategory
